export default (element) =>
  Array.prototype.slice.call(element.childNodes);



// WEBPACK FOOTER //
// ./src/lib/dom/element-children.js